import { reset } from 'redux-form';

import { formNamesExternal } from 'constants/forms';

export const resetExternalUpdatePaymentMethodForm = () => reset(formNamesExternal.UPDATE_PAYMENT_METHOD);
